<h1 mat-dialog-title>{{data.title}}</h1>
<div mat-dialog-content>
  <iframe style="width: 100%; height: 600px;" [src]="data.path"></iframe>
</div>
<div mat-dialog-actionss align="end">
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>{{data.accept}}</button>
</div>